export const defaultFormatter = (d) => d;

export const defaultMaxYAxisWidth = 200;
